import { BaseStore } from 'fluxible/addons';

export default class BookCalculatorAmountStore extends BaseStore {
    constructor(dispatcher) {
        super(dispatcher);

        this.loading = false;
        this.amounts = {
            total: 0,
            editing: 0,
            cover: 0,
            interior: 0,
            printing: 0,
            extras: 0,
        };
    }

    updateAmounts(amounts) {
        this.loading = false;
        this.amounts = amounts;
        this.emitChange();
    }

    updateStarted() {
        this.loading = true;
        this.emitChange();
    }

    updateFailed(error) {
        this.loading = false;
        console.warn('UPDATE_AMOUNTS_FAILURE', error);
        this.emitChange();
    }

    isLoading() {
        return this.loading;
    }

    getAmounts() {
        return this.amounts;
    }
}

BookCalculatorAmountStore.storeName = 'BookCalculatorAmountStore';

BookCalculatorAmountStore.handlers = {
    UPDATE_AMOUNTS_STARTED: 'updateStarted',
    UPDATE_AMOUNTS_FAILURE: 'updateFailed',
    UPDATE_AMOUNTS_SUCCESS: 'updateAmounts',
    LOAD_INITIAL_AMOUNTS: 'updateAmounts',
};
